import axios from 'axios';
import { GRANT_TYPE_REFRESH } from '../../utils/constants';
import { API } from '../../utils/api';

/**
 * @param {Object} params
 * @param {string} params.refresh_token
 * @returns {Promise<Object>} Promise resolving to the token response
 */
function getTokenUsingRefresh({ refresh_token }) {

  return axios
    .post(API.USER.getTokenUsingRefresh,
      { refresh_token }, 
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then((res) => {
      return res?.data;
   })
    .catch((error) => {
      console.error('Error fetching token:', error);
      throw error;
    });
}

export default getTokenUsingRefresh;
